export const RESET_STATE = "RESET_STATE";
export const SET_AUTH = "SET_AUTH";
export const SET_AUTH_PROPERTY = "SET_AUTH_PROPERTY";
export const SET_PO_DATA = "SET_PO_DATA";
export const SET_ORDER_PROPERTY = "SET_ORDER_PROPERTY";
export const SET_PO_TYPE = "SET_PO_TYPE";
export const SET_PO_DATA_INFO = "SET_PO_DATA_INFO";
export const SET_PO_DATA_INFO_PROPERTY = "SET_PO_DATA_INFO_PROPERTY";
export const SET_PO_APPROVED_CHECKED = "SET_PO_APPROVED_CHECKED";

export const SET_SELECT_ALL_TODAY_PO_CHECKED = "SET_SELECT_ALL_TODAY_PO_CHECKED";
export const SET_SELECT_INCOMPLETE_WEIGHING_PO_CHECKED = "SET_SELECT_INCOMPLETE_WEIGHING_PO_CHECKED";
export const SET_SELECT_TODAYS = "SET_SELECT_TODAYS";

export const SET_PO_SUPPLIER_TYPE = "SET_PO_SUPPLIER_TYPE";
export const SET_PO_SUPPLIER_ID = "SET_PO_SUPPLIER_ID";
export const SET_PO_DATA_APPROVED = "SET_PO_DATA_APPROVED";
export const SET_PO_SUPPLIER = "SET_PO_SUPPLIER";
export const SET_PO_RESTUARANT = "SET_PO_RESTUARANT";

export const SET_PO_FILTER_FIELDS = "SET_PO_FILTER_FIELDS";
export const SET_PO_SEARCH_FIELDS = "SET_PO_SEARCH_FIELDS";

export const SET_PO_APPROVED_PAGINATION = "SET_PO_APPROVED_PAGINATION";

export const SET_RL_SEARCH_FIELDS = "SET_RL_SEARCH_FIELDS";
export const SET_RL_PAGINATION = "SET_RL_PAGINATION";

export const SET_I18N = "SET_I18N";